module.exports = __webpack_public_path__ + "static/img/grow7_light.6b6d6896.png";